export default __webpack_public_path__ + "static/media/newBlogV1.803983dd.png";